import { WEM } from "../actions/actionsTypes";
import { IGlobal } from "../models/global.interface";
import { IActionBase } from "../models/root.interface";

const initialState: any = {
  wemList: null,
  filtersData: null,
  postRequestQuoteData: null
};

function wemReducer(state: any = initialState, action: IActionBase): IGlobal {
  switch (action.type) {
    case WEM.GET_WEM_FETCHING:
      return {
        ...state,
        wemList: { loading: true, data: null, err: null }
      };
    case WEM.GET_WEM_SUCCESS:
      return {
        ...state,
        wemList: { loading: false, data: action.payload.data, err: null }
      };
    case WEM.GET_WEM_ERROR:
      return {
        ...state,
        wemList: { loading: false, data: null, err: action.payload }
      };
 case WEM.GET_WEM_FILTERS_FETCHING:
      return {
        ...state,
        filtersData: { loading: true, data: null, err: null }
      };
    case WEM.GET_WEM_FILTERS_SUCCESS:
      return {
        ...state,
        filtersData: { loading: false, data: action.payload.data, err: null }
      };
    case WEM.GET_WEM_FILTERS_ERROR:
      return {
        ...state,
        filtersData: { loading: false, data: null, err: action.payload }
      };
    case WEM.POST_REQUEST_QUOTE_FETCHING:
      return {
        ...state,
        postRequestQuoteData: { loading: true, data: null, err: null }
      };
    case WEM.POST_REQUEST_QUOTE_SUCCESS:
      return {
        ...state,
        postRequestQuoteData: { loading: false, data: action.payload.data, err: null }
      };
    case WEM.POST_REQUEST_QUOTE_ERROR:
      return {
        ...state,
        postRequestQuoteData: { loading: false, data: null, err: action.payload }
      };

    default:
      return state;
  }
};

export default wemReducer;
